import { Link } from 'react-router-dom';

export default function FaqCta() {
  return (
    <section className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="bg-[#5C5470] rounded-3xl p-10 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            {/* Left */}
            <div className="text-center lg:text-left max-w-xl">
              <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
                STILL HAVE QUESTIONS?
              </p>
              <h2
                className="font-serif font-bold text-white mb-5"
                style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
              >
                FAQ 看完了，還想知道
                <br />
                自己的情況怎麼配置？
              </h2>
              <p className="text-white/75" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                每個人的家庭責任、健康狀況與預算不同，建議透過一對一諮詢確認，讓琮恩根據您的實際狀況提供最適合的建議。
              </p>
            </div>

            {/* Right */}
            <div className="flex flex-col gap-4 flex-shrink-0 w-full lg:w-auto">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
                style={{ fontSize: '1.1875rem' }}
              >
                <i className="ri-calendar-check-line"></i>
                預約諮詢
              </Link>
              <Link
                to="/about#health-check-form"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:border-white hover:bg-white/10 transition-all duration-200"
                style={{ fontSize: '1.1875rem' }}
              >
                <i className="ri-file-search-line"></i>
                免費保單健檢
              </Link>
            </div>
          </div>

          {/* Bottom trust row */}
          <div className="mt-12 pt-10 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-question-answer-line', text: '12 題常見問題整理' },
              { icon: 'ri-shield-check-line', text: '持照顧問專業解答' },
              { icon: 'ri-chat-smile-3-line', text: '用白話文說清楚' },
              { icon: 'ri-refresh-line', text: '內容持續更新' },
            ].map((b) => (
              <div key={b.text} className="flex items-center gap-3 text-white/70">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${b.icon} text-[#D4A373] text-xl`}></i>
                </div>
                <span style={{ fontSize: '1.0625rem' }}>{b.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
